import { getFieldIdByUuid } from 'fields/selectors';
import { getBoundariesByFieldUuid } from 'boundaries/selectors';
import { getActiveUserId } from 'current/selectors';
import { fetchFieldBoundariesByFieldId } from 'boundaries/loaders';
import { processFieldBoundariesByFieldUuid } from 'boundaries/processors';

import { isEmpty } from 'lodash';

export const findFieldBoundariesByFieldUuid = ({ dispatch, getState, fieldUuid }) => {
  return Promise.resolve() // force a thenable wrapper
  .then( () => {
    const state = getState();
    const boundaries = getBoundariesByFieldUuid(state, fieldUuid);
    if( !isEmpty(boundaries) ) {
      return boundaries;
    }
    const userId = getActiveUserId(state);
    const fieldId = getFieldIdByUuid(state, fieldUuid); // If we wanted fieldId, why were we using fieldUuid?
    return fetchFieldBoundariesByFieldId({ userId, fieldId })
    .then( (rawBoundaries) => processFieldBoundariesByFieldUuid({ dispatch, getState, fieldUuid, rawBoundaries }) );
  });
};
